/**
 * AR Custom YMM Widget & Collection Filter
 * Replaces Findter Filter & Search app
 * 
 * Features:
 * 1. YMM Widget — cascading Year/Make/Model dropdowns
 * 2. Collection page — pre-select dropdowns from URL params + filter products
 * 3. Dynamic header on filtered collection pages
 */

(function() {
  'use strict';

  window.AR_YMM_DATA = window.AR_YMM_DATA || { makes: [], models: [], years: [] };
  window.AR_COLLECTION_MAP = window.AR_COLLECTION_MAP || {};
  window.AR_COLLECTION_HANDLE_MAP = window.AR_COLLECTION_HANDLE_MAP || {};

  // ============================================================
  // YMM WIDGET — Renders cascading dropdowns
  // ============================================================
  
  function initYmmWidget() {
    const widget = document.querySelector('#ar-ymm-widget') || document.querySelector('ar-ymm-widget');
    if (!widget) return;

    // Apply page-width constraint to the widget container
    // <main> is display:flex; flex-direction:column, so children don't stretch by default
    widget.style.setProperty('width', '100%', 'important');
    widget.style.setProperty('align-self', 'center', 'important');
    widget.style.setProperty('margin-left', 'auto', 'important');
    widget.style.setProperty('margin-right', 'auto', 'important');
    widget.style.setProperty('padding-left', '20px', 'important');
    widget.style.setProperty('padding-right', '20px', 'important');
    widget.style.setProperty('box-sizing', 'border-box', 'important');
    
    const showAlways = widget.getAttribute('data-show-always') === 'true';
    if (!showAlways) {
      const params = new URLSearchParams(window.location.search);
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      if (params.get('ymm') !== 'true' && hashParams.get('ymm') !== 'true') {
        widget.remove();
        return;
      }
    }
    
    const actionUrl = widget.getAttribute('data-action-url') || '/collections/all';
    const title = widget.getAttribute('data-title') || 'Filter Parts By';
    const placeholder = widget.getAttribute('data-placeholder') || 'Select...';
    const submitLabel = widget.getAttribute('data-submit-label') || 'Search';
    const resetLabel = widget.getAttribute('data-reset-label') || 'Reset';
    const layout = widget.getAttribute('data-layout') || 'vertical';
    
    const formHtml = `
      <div class="ar-ymm-widget ar-ymm-widget--${layout}">
        <form class="ar-ymm-form" method="get" action="${actionUrl}" novalidate>
          <div class="ar-ymm-header">
            <h2 class="ar-ymm-title">${title}</h2>
            <button type="button" class="ar-ymm-reset">${resetLabel}</button>
          </div>
          <div class="ar-ymm-selects-row">
            <div class="ar-ymm-selects">
              <div class="ar-ymm-select" data-source="vendor">
                <label class="ar-ymm-label">Vehicle Make</label>
                <select class="ar-ymm-select__control" name="vendor">
                  <option value="">${placeholder}</option>
                  ${AR_YMM_DATA.makes.map(m => `<option value="${m}">${m}</option>`).join('')}
                </select>
              </div>
              <div class="ar-ymm-select is-disabled" data-source="collection">
                <label class="ar-ymm-label">Model</label>
                <select class="ar-ymm-select__control" name="collection" disabled>
                  <option value="">${placeholder}</option>
                  ${AR_YMM_DATA.models.map(m => `<option value="${m.gid}">${m.name}</option>`).join('')}
                </select>
              </div>
              <div class="ar-ymm-select is-disabled" data-source="tags">
                <label class="ar-ymm-label">Year</label>
                <select class="ar-ymm-select__control" name="tags" disabled>
                  <option value="">${placeholder}</option>
                  ${AR_YMM_DATA.years.map(y => `<option value="${y}">${y}</option>`).join('')}
                </select>
              </div>
            </div>
            <button type="submit" class="ar-ymm-submit" disabled>${submitLabel}</button>
          </div>
          <input type="hidden" name="ymm" value="true">
        </form>
      </div>
    `;
    
    widget.innerHTML = formHtml;
    widget.removeAttribute('hidden');
    
    const form = widget.querySelector('.ar-ymm-form');
    const makeSelect = form.querySelector('[name="vendor"]');
    const modelSelect = form.querySelector('[name="collection"]');
    const yearSelect = form.querySelector('[name="tags"]');
    const submitBtn = form.querySelector('.ar-ymm-submit');
    const resetBtn = form.querySelector('.ar-ymm-reset');
    
    // Pre-select from URL params or hash params (results page after redirect)
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const urlVendor = urlParams.get('vendor') || hashParams.get('vendor') || '';
    const urlCollection = urlParams.get('collection') || hashParams.get('collection') || '';
    const urlTags = urlParams.get('tags') || hashParams.get('year') || '';
    
    // Update H1 heading to "Make - Model - Year" from hash params
    const hashVendor = hashParams.get('vendor') || '';
    const hashModel = hashParams.get('model') || '';
    const hashYear = hashParams.get('year') || '';
    if (hashVendor && hashModel) {
      const h1 = document.querySelector('h1');
      if (h1) {
        var heading = hashVendor + ' - ' + hashModel;
        if (hashYear) heading += ' - ' + hashYear;
        h1.textContent = heading;
        document.title = heading + ' - AR Bodyworks';
      }
    }
    
    if (urlVendor) {
      makeSelect.value = urlVendor;
      makeSelect.dispatchEvent(new Event('change'));
      if (urlCollection) {
        modelSelect.value = urlCollection;
        modelSelect.dispatchEvent(new Event('change'));
        if (urlTags) {
          yearSelect.value = urlTags;
        }
      } else if (hashModel) {
        // After redirect, model comes as a name not GID — find matching option
        Array.from(modelSelect.options).forEach(function(opt) {
          if (opt.value && AR_YMM_DATA.models.find(function(m){ return m.gid === opt.value && m.name === hashModel; })) {
            modelSelect.value = opt.value;
          }
        });
        if (modelSelect.value) {
          modelSelect.dispatchEvent(new Event('change'));
          if (hashYear) yearSelect.value = hashYear;
        }
      }
    }
    
    // Cascading: Make → filter Models
    makeSelect.addEventListener('change', function() {
      const selectedMake = this.value;
      modelSelect.value = '';
      yearSelect.value = '';
      if (selectedMake) {
        modelSelect.disabled = false;
        modelSelect.parentElement.classList.remove('is-disabled');
        Array.from(modelSelect.options).forEach(opt => {
          if (opt.value === '') return;
          const model = AR_YMM_DATA.models.find(m => m.gid === opt.value);
          opt.style.display = (model && model.vendor === selectedMake) ? '' : 'none';
        });
        // Enable submit with just Make selected
        submitBtn.disabled = false;
      } else {
        modelSelect.disabled = true;
        modelSelect.parentElement.classList.add('is-disabled');
        submitBtn.disabled = true;
      }
      yearSelect.disabled = true;
      yearSelect.parentElement.classList.add('is-disabled');
    });
    
    modelSelect.addEventListener('change', function() {
      if (this.value) {
        yearSelect.disabled = false;
        yearSelect.parentElement.classList.remove('is-disabled');
      } else {
        yearSelect.disabled = true;
        yearSelect.parentElement.classList.add('is-disabled');
      }
      // Submit stays enabled as long as Make is selected
    });
    
    yearSelect.addEventListener('change', function() {});
    
    resetBtn.addEventListener('click', function() {
      makeSelect.value = '';
      makeSelect.dispatchEvent(new Event('change'));
    });
    
    form.addEventListener('submit', function() {
      if (typeof window.showArLoadingOverlay === 'function') {
        window.showArLoadingOverlay();
      }
    });
  }

  // ============================================================
  // COLLECTION PAGE — Filter products via AJAX
  // ============================================================
  
  // Collection filtering is handled inline in the collection.json template
  // to avoid CDN caching issues with the external JS file.
  
  function showMatchingProducts(handles, retries) {
    retries = retries || 0;
    const grid = document.querySelector('.product-grid');
    if (!grid) {
      if (retries < 20) {
        setTimeout(() => showMatchingProducts(handles, retries + 1), 500);
      }
      return;
    }
    
    // Wait for product cards to render in the grid
    const cards = grid.querySelectorAll('product-card');
    if (cards.length === 0 && retries < 20) {
      setTimeout(() => showMatchingProducts(handles, retries + 1), 500);
      return;
    }
    
    if (handles.length === 0) {
      grid.innerHTML = '<li class="product-grid__item"><p>No products found for your selection.</p></li>';
      document.getElementById('ar-ymm-hide-grid')?.remove(); document.getElementById('ar-ymm-filter-style')?.remove();
      return;
    }
    
    const handleSet = new Set(handles);
    let visibleCount = 0;
    
    grid.querySelectorAll('product-card').forEach(card => {
      const link = card.querySelector('a[href*="/products/"]');
      if (link) {
        const href = link.getAttribute('href');
        const handle = href.split('/products/')[1]?.split('?')[0];
        if (handle && handleSet.has(handle)) {
          card.parentElement.style.display = '';
          visibleCount++;
        } else {
          card.parentElement.style.display = 'none';
        }
      }
    });
    
    if (visibleCount === 0 && cards.length > 0) {
      // Products loaded but none matched — render the matching ones ourselves
      grid.innerHTML = handles.map(h => 
        `<li class="product-grid__item"><a href="/products/${h}">${h.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</a></li>`
      ).join('');
    } else if (visibleCount === 0 && cards.length === 0) {
      grid.innerHTML = '<li class="product-grid__item"><p>No products found for your selection.</p></li>';
    }
    
    // Show the grid now that filtering is complete
    document.getElementById('ar-ymm-hide-grid')?.remove(); document.getElementById('ar-ymm-filter-style')?.remove();
    
    // Stop infinite scroll
    const resultsList = document.querySelector('results-list');
    if (resultsList) {
      resultsList.removeAttribute('infinite-scroll');
    }
  }

  // ============================================================
  // INIT
  // ============================================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initYmmWidget();
    });
  } else {
    initYmmWidget();
  }
})();